import type { ViewMode } from "../../../shared/types";
import {
  CalendarIcon,
  CheckSquare,
  Flame,
  ListIcon,
  BarChart3,
  ClockIcon,
  CalendarWeekIcon,
  LayoutGridIcon,
  GridIcon,
  BookIcon,
  KanbanIcon,
} from "../../../ui/icons";
import { ToggleRow } from "./SettingsUIComponents";

interface SectionItem {
  readonly mode: ViewMode;
  readonly label: string;
  readonly description: string;
  readonly icon: (props: { readonly className?: string }) => React.ReactNode;
}

const TOGGLEABLE_SECTIONS: ReadonlyArray<SectionItem> = [
  { mode: "tasks", label: "Taches", description: "Liste des taches", icon: CheckSquare },
  { mode: "habits", label: "Habitudes", description: "Suivi des habitudes", icon: Flame },
  { mode: "calendar", label: "Calendrier", description: "Vue calendrier mensuelle", icon: CalendarIcon },
  { mode: "agenda", label: "Agenda", description: "Vue agenda chronologique", icon: ListIcon },
  { mode: "weekly", label: "Semaine", description: "Vue semaine detaillee", icon: CalendarWeekIcon },
  { mode: "schedule", label: "Emploi du temps", description: "Grille horaire", icon: LayoutGridIcon },
  { mode: "stats", label: "Stats", description: "Statistiques et graphiques", icon: BarChart3 },
  { mode: "free-slots", label: "Creneaux libres", description: "Trouver du temps libre", icon: ClockIcon },
  { mode: "kanban", label: "Kanban", description: "Tableau kanban", icon: KanbanIcon },
  { mode: "eisenhower", label: "Eisenhower", description: "Matrice de priorites", icon: GridIcon },
  { mode: "journal", label: "Journal", description: "Journal quotidien", icon: BookIcon },
];

interface SectionsSectionProps {
  readonly hiddenSections: ReadonlySet<ViewMode>;
  readonly advancedMode: boolean;
  readonly onToggleSection: (mode: ViewMode) => void;
}

const ADVANCED_MODES = new Set<ViewMode>(["kanban", "eisenhower", "journal"]);

export function SectionsSection({
  hiddenSections,
  advancedMode,
  onToggleSection,
}: SectionsSectionProps) {
  const visibleSections = advancedMode
    ? TOGGLEABLE_SECTIONS
    : TOGGLEABLE_SECTIONS.filter((s) => !ADVANCED_MODES.has(s.mode));

  return (
    <div className="flex flex-col gap-1">
      <p className="text-[11px] text-ink-muted mb-2">
        Masquez les sections que vous n'utilisez pas. Elles disparaitront de la navigation.
      </p>
      {visibleSections.map(({ mode, label, description, icon: Icon }) => (
        <div key={mode} className="flex items-center gap-2.5">
          <Icon className="w-3.5 h-3.5 text-ink-muted shrink-0" />
          <div className="flex-1 min-w-0">
            <ToggleRow
              label={label}
              description={description}
              checked={!hiddenSections.has(mode)}
              onChange={() => onToggleSection(mode)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
